import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_conduct_worker_performance_evaluations_based_on_a'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_conduct_worker_performance_evaluations_based_on_a',
  name: 'Does the facility conduct worker performance evaluations based on a standard set of criteria? ',
  description:
    "The intent of this question is to understand if facility's conduct worker performance evaluations. Performance evaluations are an assessment and review of the worker's job performance. Discrimination can be minimalized when the evaluation is based on objective and transparent metrics.\r\r\n\r\r\nExamples of performance evaluation criteria might include: Workers' attendance records, productivity output, quality of work, new skills acquired, communication style, disciplinary issues, attitude and demeanor, etc. ",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8330,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
